var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubBarGlobal',{attrs:{"currentCrumb":_vm.crumbName}},[(_vm.$route.path == '/')?[_c('div',{staticClass:"mr-4 d-none d-xl-block dash-divider"})]:_vm._e(),_c('PageButtons')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }